var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project wrapper"},[_c('h1',[_vm._v(_vm._s(_vm.project.title))]),_vm._v(" "),_c('img',{attrs:{"src":("/static/img/" + (_vm.project.image)),"alt":_vm.project.image}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.project.about))]),_vm._v(" "),_c('a',{attrs:{"href":("" + (_vm.project.url))}},[_vm._v("Visit page..")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdd2f98e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/project.vue
// module id = null
// module chunks = 